exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "[data-player] .highlight-capture-plugin-camera-container {\n  display: inline-block;\n  height: 32px;\n  padding: 9px 12px 0 5px;\n  vertical-align: top; }\n  [data-player] .highlight-capture-plugin-camera-container a {\n    color: #fff;\n    opacity: 1; }\n  [data-player] .highlight-capture-plugin-camera-container a:hover {\n    opacity: 0.8; }\n\n[data-player] i.fa {\n  font: normal normal normal 14px/1 FontAwesome; }\n\n[data-player] .highlight-form {\n  position: relative;\n  z-index: 1;\n  pointer-events: all;\n  background: rgba(0, 0, 0, 0.2);\n  padding: 10px; }\n  [data-player] .highlight-form .close-container {\n    float: right; }\n    [data-player] .highlight-form .close-container i {\n      cursor: pointer;\n      color: #fff;\n      opacity: 1; }\n  [data-player] .highlight-form i.refresh-start-time {\n    cursor: pointer; }\n  [data-player] .highlight-form input,\n  [data-player] .highlight-form select {\n    color: #333; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/postcss-loader!../node_modules/sass-loader!./player/highlight-capture-plugin.scss
// module id = 448
// module chunks = 3